<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="page-top-wrap">
            <div class="top">
                <div class="top-wrap">
                    <div class="wrap">
                        <span class="bold">Untact 수업 환경 Test&nbsp;<img src="../assets/img/qeustion.png" @click="guideDown()"  class="cur-pointer pdf-img"/></span>
                        <p>Untact 수업 준비, 어렵지 않아요!<br>수업 전, 수업을 위한 프로그램을 다운받고<br>Test Room에서 환경 Test를 진행해 주세요!</p>
                        <button @click="programDown()">프로그램 다운받기 (Webex meetings)</button>
                        <button class="room mt-10" @click="testRoom()">Test Room 입장하기</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="untact-page-top">
            <div class="top wrap clear">
                <h2 class="bold  float-left">Untact 수업 환경 문의</h2><br>
                <p>혹시 수업 환경 Test 중에 문제가 있으신가요?<br>문의주시면 빠른 시간 내에 도움 드리겠습니다.</p>
            </div>
        </div>
        <div class="untact-wrap">
            <div class="untact-none-list" v-if="list.length == 0">
                <p>등록된 문의사항이 없습니다.</p>
                <button @click="goAdd()">문의하기</button>
            </div>
            <div class="untact-list" v-else>
                <ul>
                    <li v-for="(item,index) in list" :key="index" @click="goView(item.idx)">
                        <div class="wrap clear">
                            <span v-if="item.state == 1">접수중</span>
                            <span v-if="item.state == 2" class="on">진행중</span>
                            <span v-if="item.state == 3" class="complete">답변완료</span>
                            <h1>{{item.title}}&nbsp;&nbsp;<img src="../assets/img/comment_icon.png" v-if="item.answer_idx != null" /></h1>
                            <p>{{item.cratedate}}</p>
                        </div>
                    </li>
                    <!-- <li>
                        <div class="wrap clear">
                            <span class="on">진행중</span>
                            <h1>문의 드립니다.</h1>
                            <p>2020-07-10</p>
                        </div>
                    </li>
                    <li>
                        <div class="wrap clear">
                            <span class="complete">답변완료</span>
                            <h1>문의 드립니다.</h1>
                            <p>2020-07-10</p>
                        </div>
                    </li>
                    <li>
                        <div class="wrap clear">
                            <span class="complete">답변완료</span>
                            <h1>문의 드립니다. <img src="../assets/img/comment_icon.png" /></h1>
                            <p>2020-07-10</p>
                        </div>
                    </li> -->
                </ul>
                <div class="btn">
                    <button @click="goAdd()">문의하기</button>
                </div>
            </div>

        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'untactTest',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        list: []
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.getList();
    },
    methods: {
        guideDown() {
            window.open("https://hq.carrotenglish.net/carrotdata/guide/200723_untact.pdf");
            // location.href="https://help.webex.com/ld-nyw95a4-CiscoWebexMeetings/Webex-Meetings#Download-and-Install";
        },
        goView(idx) {
            // alert(idx);
            location.href = "/untactview?q_idx=" + idx;
        },
        programDown() {
            window.open('https://www.webex.com/downloads.html');
        },
        testRoom() {
            window.open('https://www.webex.com/test-meeting.html');
        },
        getList() {
            var me = this;
            var params = {
                idx_member: localStorage.getItem("uidx")
            }
            this.axios.get(this.$store.state.host + "/rest/mobile/untact_question_stdlist", {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.list = res.data.list;
                    console.log(me.list);
                } else {
                    alert(res.data.err_msg);
                }
            });
        },
        goAdd() {
            location.href = "/untactadd"
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.untact-wrap {
    width: 1200px;
    margin: 0 auto;
}
.pdf-img{
    width: 20px;
}
.class {
    // width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    .page-top-wrap {
        width: 100%;

        .top {
            // padding-right: 20px;
            padding-bottom: 17px;
            // background: url("../assets/img/top-bg.png") no-repeat right -80px;
            background-size: 300px;
            position: relative;

            .top-wrap {
                background: #53CAFF 0% 0% no-repeat padding-box;

                .wrap {
                    text-align: center;
                    padding-top: 25px;
                    padding-bottom: 25px;

                    span {
                        font-size: 18px;
                        letter-spacing: 0px;
                        color: #FFFFFF;
                        opacity: 1;
                    }

                    p {
                        font-size: 14px;
                        letter-spacing: -0.28px;
                        color: #FFFFFF;
                        opacity: 1;
                        margin-top: 10px;
                    }

                    button {
                        width: 100%;
                        text-align: center;
                        font-size: 16px;
                        letter-spacing: 0px;
                        color: #53CAFF;
                        opacity: 1;
                        border: none;
                        background: #FFFFFF 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding-top: 14px;
                        padding-bottom: 14px;
                        margin-top: 19px;
                        cursor: pointer;
                        font-weight: bold;
                    }

                    button.room {
                        background: #6974FF;
                        color: white;
                    }
                }
            }

        }

    }

    .untact-page-top {
        width: 100%;
        border-bottom: 10px solid #F5F5F5;
        padding-bottom: 20px;

        .top {
            // padding-right: 20px;
            // background: url("../assets/img/top-bg.png") no-repeat right -80px;
            position: relative;

            .my-reason {
                position: absolute;
                right: 0;
                bottom: 15%;
            }

            p {
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                margin-top: 20px;
            }

            div {
                select {
                    border: 1px solid var(--unnamed-color-53caff);
                    background: #FFFFFF 0% 0% no-repeat padding-box;
                    border: 1px solid #53CAFF;
                    border-radius: 4px;
                    opacity: 1;
                    color: #53CAFF;
                    ;
                }
            }
        }
    }

    .untact-wrap {
        .untact-none-list {
            text-align: center;

            p {
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
                padding-top: 40px;
                padding-bottom: 15px;
            }

            button {
                background: #53CAFF 0% 0% no-repeat padding-box;
                border-radius: 3px;
                opacity: 1;
                font-size: 14px;
                letter-spacing: 0px;
                color: #FFFFFF;
                opacity: 1;
                border: none;
                padding: 5px 10px;
            }
        }

        .untact-list {
            ul {
                li {
                    border-bottom: 1px dashed #E9E9E9;
                    padding-top: 15px;
                    padding-bottom: 15px;
                    cursor: pointer;

                    div {
                        position: relative;

                        span {
                            background: #F5F5F5 0% 0% no-repeat padding-box;
                            border-radius: 12px;
                            font-size: 12px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                            font-weight: bold;
                            padding-left: 10px;
                            padding-right: 10px;
                            float: left;
                        }

                        span.on {
                            color: #53CAFF;
                        }

                        span.complete {
                            background: #53CAFF 0% 0% no-repeat padding-box;
                            border-radius: 12px;
                            font-size: 12px;
                            font-weight: bold;
                            letter-spacing: 0px;
                            color: #FFFFFF;
                            opacity: 1;
                        }

                        h1 {
                            float: right;
                            width: 80%;
                            font-size: 16px;
                            font-weight: bold;
                            letter-spacing: 0px;
                            color: #000000;
                            opacity: 1;
                            padding-left: 5px;
                            img{
                                width: 15px;
                            }
                        }

                        p {
                            position: absolute;
                            right: 0;
                            top: 0;
                            font-size: 11px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                        }
                    }
                }
            }

            .btn {
                text-align: right;
                width: 90%;
                padding-top: 20px;

                button {
                    background: #53CAFF 0% 0% no-repeat padding-box;
                    border-radius: 3px;
                    opacity: 1;
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #FFFFFF;
                    opacity: 1;
                    padding: 5px 10px;
                    border: none;
                }
            }
        }
    }
}

.footer {
    position: static;
}

.btn {
    width: 90%;
    max-width: 700px;
    margin: 0 auto;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;

        .top {
            padding-top: 60px;
        }
    }

    .untact-wrap {
        width: 100%;
    }
    // .class .untact-page-top .top[data-v-0594649c]
    .untact-page-top{
        .top{
            padding-top: 0px;
        }
    }
}
</style>
